/**
 *
 * ProductUnlinked index file.
 *
 */

import ProductUnlinked from "./ProductUnlinked";

export default ProductUnlinked;
